import BackgroundPlayer from "../../../components/BackgroundVideo/BackgroundPlayer";
import ChannelsTemplate from "../../../templates/desktop/WebsiteTemplate/ChannelsTemplate";
import Page from "../../../components/General/Page";
import { PMCPlayer, PMCVideoPlayer } from "../../../components/Player/PMCVideoPlayer";
import { createRef } from "react";
const MusicChannel = ({className, style}) => {
    const refPlayer = createRef(null);
    return (
        <Page path={"/music"} title="PMC MUSIC" description={"Persian and international music videos"}>
            <ChannelsTemplate style={style} className={className}>
                <PMCVideoPlayer 
                    ref={refPlayer}
                    src={"https://cdn3.wowza.com/1/ZDBESEcyZ3MyMkVo/YTNwTXZ1/hls/live/playlist.m3u8"} 
                />
                
            </ChannelsTemplate>
        </Page>
        
    )
};
export default MusicChannel;